import { toast } from "react-toastify";
import {jwtDecode} from 'jwt-decode';
import CryptoJS from 'crypto-js';


const iterations = 100;
const keyLength = 256;
const importAlgorithm = { name: 'PBKDF2' };
const derivedKeyAlgorithm = {
  name: 'AES-CBC',
  length: keyLength
};

export const updateObject = (oldObject, updatedProperties) => {
  return {
    ...oldObject,
    ...updatedProperties,
  };
};

export const cookieFunc = {
  set: function(name, value, seconds) {
    let expires = "";
    if (seconds) {
      let date = new Date();
      date.setTime(date.getTime() + seconds * 1000);
      expires = "; expires=" + date.toUTCString();
    }
    document.cookie = name + "=" + (value || "") + expires + "; path=/";
  },
  get: function(name) {
    const cname = name + "=";
    const ca = document.cookie.split(";");
    for (let i = 0; i < ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) === " ") {
        c = c.substring(1, c.length);
      }
      if (c.indexOf(cname) === 0) {
        return c.substring(cname.length, c.length);
      }
    }
    return null;
  },
  erase: function(name) {
    document.cookie =
      name + "=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;";
  },
};

// export const localStorageFunc = {
//   get: function(key) {
//     const value = localStorage[key];
//     if (value != null) {
//       /*const model = JSON.parse(value);
// 			if (model.payload != null && model.expiry != null) {
// 				const now = new Date();
// 				if (now > Date.parse(model.expiry)) {
// 					localStorage.removeItem(key);
// 					return null;
// 				}
// 			}*/
//       return value;
//     }
//     return null;
//   },
//   set: function(key, value, expirySeconds) {
//     let expiryDate = new Date();
//     expiryDate.setSeconds(expiryDate.getSeconds() + expirySeconds);
//     localStorage[key] = value;
//     /*localStorage[key] = JSON.stringify({
// 			payload: value,
// 			expiry: expiryDate,
// 		});*/
//   },
//   erase: function(key) {
//     localStorage.removeItem(key);
//   },
//   eraseAll: function() {
//     localStorage.clear();
//   },
// };

export const localStorageFunc = {
  set: (key, value, expirySeconds) => {
    let expiryDate = new Date();
    expiryDate.setSeconds(expiryDate.getSeconds() + expirySeconds);
    localStorage.setItem(key, value);
  },
  get: (key) => {
    return localStorage.getItem(key);
  },
  erase: (key) => {
    localStorage.removeItem(key);
  },
  eraseAll: () => {
    localStorage.clear();
  }
};


export const currentTimeGMT = (gmtTime, operation, strdiff) => {
  let d = new Date();
  d.setTime(gmtTime * 1000);
  let offset = d.getTimezoneOffset() * 60000;
  if (operation === "sum") {
    offset = offset + strdiff * 1000;
  } else {
    offset = offset - strdiff * 1000;
  }
  d.setTime(d.getTime() + offset);
  return d;
};

export const currentTime = (d, gmtTime) => {
  d.setTime(d.getTime() + gmtTime * (gmtTime === 1 ? 10000 : 60000));
  const fullYear = d.getFullYear();
  let fullMonth = d.getMonth() + 1;
  fullMonth = fullMonth < 10 ? "0" + fullMonth : fullMonth;
  let fullDay = d.getDate();
  fullDay = fullDay < 10 ? "0" + fullDay : fullDay;
  let fullHours = d.getHours();
  fullHours = fullHours < 10 ? "0" + fullHours : fullHours;
  let fullMinutes = d.getMinutes();
  fullMinutes = fullMinutes < 10 ? "0" + fullMinutes : fullMinutes;
  return [fullYear, fullMonth, fullDay, fullHours, fullMinutes];
};

export const secToTime = (secs) => {
  try {
    secs = parseInt(secs);
  } catch (e) {
    secs = 0;
  }
  if (secs) {
    const date = new Date(0);
    date.setSeconds(secs);
    const timeString = date.toISOString().substr(11, 8);
    return timeString;
  }
  return "00:00:00";
};

export const notify = (msg, id, type, position, time) => {
  position = position ? position : "BOTTOM_LEFT";
  time = time ? time : 4000;
  type = type ? type : "error";
  toast[type](msg, {
    position: toast.POSITION[position],
    autoClose: time,
    toastId: id,
  });
  // type - success,error,warn,info
  // position - TOP_RIGHT,TOP_CENTER,TOP_LEFT,BOTTOM_RIGHT,BOTTOM_CENTER,BOTTOM_LEFT
};

export const upperCaseFirstLetter = (string) => {
  return string.charAt(0).toUpperCase() + string.slice(1);
};

export const lowerCaseAllWordsExceptFirstLetters = (string) => {
  return string.replace(/\S*/g, function(word) {
    return upperCaseFirstLetter(word.charAt(0) + word.slice(1).toLowerCase());
  });
};

export const agentConfig = {
  clientIP: "127.0.0.1",
};

function isEncryptedNumber(number) {
  try {
    if (!number) return false;

    number = number.trim();
    if (/^[0-9]+$/.test(number)) return false;
    if (/^[A-Za-z]{1,2}\d+$/.test(number)) return false;
    const hasUpper = /[A-Z]/.test(number);
    const hasLower = /[a-z]/.test(number);
    if (hasUpper || hasLower) return true;
    // Case 4: Base64-like
    if (/=/.test(number) || /[+/]/.test(number)) return true;
    return false;
  } catch (error) {
    console.log("Error detecting encryption:", error.message);
    return false;
  }
}



export const decryptPhoneNumber = (encryptedNumber) => {
  const password = window.Configs.encrypt_pwd;
  if (!isEncryptedNumber(encryptedNumber)) {
    // console.log("The provided number is not encrypted.");
    return encryptedNumber;
  }
  try {
    return decrypt(encryptedNumber, password);
  } catch (error) {
    console.error("Error decrypting phone number:", error);

    return encryptedNumber;
  }
};


export const maskedNumber = (number, start, end) => {
  if (!number) return number;

  try {
    const shouldDecrypt = isEncryptedNumber(number);
    const phoneToMask = shouldDecrypt ? decryptPhoneNumber(number) : number;

    const str = phoneToMask.toString();
    const length = str.length;
    let maskedNum = "";

    for (let i = 0; i < length; i++) {
      if (i >= parseInt(start) && i < length - parseInt(end)) {
        maskedNum += "X";
      } else {
        maskedNum += str[i];
      }
    }

    return maskedNum;
  } catch (error) {
    console.error("Error during masking:", error.message);
    return number;
  }
};


const decrypt = (input, password) => {
  
  try {
    if (typeof input !== 'string' || !input) {
      return null;
    }
    const arr = input.split("");
    const arrPass = password.split("");
    let lastPassLetter = 0;
    let decrypted = "";
    let i;

    for (i = 0; i < arr.length; i++) {
      const letter = arr[i];
      const passwordLetter = arrPass[lastPassLetter];
      const temp = getInvertedLetterFromAlphabetForLetter(
        passwordLetter,
        letter
      );

      if (temp) {
        decrypted += temp;
      } else {
        console.error("Decryption error");
        return null;
      }

      if (lastPassLetter === arrPass.length - 1) {
        lastPassLetter = 0;
      } else {
        lastPassLetter++;
      }
    }

    let actual_number = atob(decrypted);
    actual_number = isNumeric(actual_number) ? actual_number : arr[i - 1];
    return actual_number;
  } catch (error) {
    console.info("Call Decryption failed:", error.message);
    return null;
  }
};


const isNumeric = (n) => {
  return !isNaN(parseFloat(n)) && isFinite(n);
};

const getInvertedLetterFromAlphabetForLetter = (letter, letterToChange) => {
  const abc = "abcdefghijklmnopqrstuvwxyz0123456789=ABCDEFGHIJKLMNOPQRSTUVWXYZ";
  const posLetter = abc.indexOf(letter);

  if (posLetter === -1) {
    throw new Error(`Password letter ${letter} not allowed.`);
  }

  const part1 = abc.substring(posLetter);
  const part2 = abc.substring(0, posLetter);
  const newABC = part1 + part2;

  const posLetterToChange = newABC.indexOf(letterToChange);

  if (posLetterToChange === -1) {
    throw new Error(`Password letter ${letter} not allowed.`);
  }

  return abc.split("")[posLetterToChange];
};


// for Date And Time

export const getDateTime = (value, gmtdiff ) => {
const stringTime = new Date().toLocaleString('en-US', {timeZone: gmtdiff});
  let endDate = new Date(stringTime);
  let startDate = new Date(stringTime);
  startDate.setHours(0, 0, 0, 0);
  
  if (value === "Yesterday") {
    startDate.setDate(startDate.getDate() - 1);
    endDate.setHours(23, 59, 59, 999); 
    endDate.setDate(endDate.getDate() - 1); 
  } else if (value === "Week") {
    let dayOfWeek = startDate.getDay();
    startDate.setDate(startDate.getDate() - dayOfWeek + (dayOfWeek === 0 ? -6 : 1));
  } else if (value === "Month") {
    startDate.setDate(1);
  }

  // Format startDate and endDate
  const formatDateTime = (date) => {
    return `${date.getFullYear()}-${("0" + (date.getMonth() + 1)).slice(-2)}-${("0" + date.getDate()).slice(-2)} ${("0" + date.getHours()).slice(-2)}:${("0" + date.getMinutes()).slice(-2)}:${("0" + date.getSeconds()).slice(-2)}`;
  };

  // Return the formatted start and end dates
  return { startDate: formatDateTime(startDate), endDate: formatDateTime(endDate) };
};


// For OKTA Integration

export const decodeToken = async () => {
  const token = localStorageFunc.get("accessToken");
    if (token) {
        const decodedToken = token ? await jwtDecode(token) : null;
        return decodedToken;
    } else {
        return null;
    }
};


//  Crypto JS - Encrypt & Decrypt token object 


const generateHash = async (text) => {
  const hashVal = await CryptoJS[window.Configs.crypto_hash_algo](text).toString(CryptoJS.enc.Hex);
  return hashVal;
}

const generateIV = async () => {
  const iv = await CryptoJS.lib.WordArray.random(16);
  return iv;
}

const generateKey = async () => {
  const key = await CryptoJS.PBKDF2(window.Configs.crypto_passphrase, window.Configs.crypto_salt, {
    keySize: keyLength,
    iterations: iterations,
  });
  const keyHex = key.toString(CryptoJS.enc.Hex);
  return keyHex;
}
// Function to encrypt data using AES

const encryptData = async () => {
  const iv = await generateIV();
  const key = await generateKey();
  const data = await decodeToken();
  const encObj = {};
  if (typeof (data) === "object") {
    Object.keys(data).map(async idx => {
      let encryptedData = await CryptoJS.AES.encrypt(data[idx], key, { iv: iv }).toString();
      encObj[idx] = encryptedData;
    });
    return encObj;
  }
  else if (typeof (data) === "string") {
    let encryptedData = await CryptoJS.AES.encrypt(data, key, { iv: iv }).toString();
    return encryptedData;
  }
  else {
    return false;
  }
}

// Function to decrypt AES-encrypted data
export const decryptData = async () => {
  const decryptObj = {};
  const iv = await generateIV();
  const key = await generateKey();
  const encryptedData = await decodeToken();
  if (encryptedData === null) {
    return null;
  }
  if (typeof (encryptedData) === "object") {
    Object.keys(encryptedData).map(async idx => {
      let decryptedDataRow =  CryptoJS.AES.decrypt(encryptedData[idx], key, { iv: iv }).toString(CryptoJS.enc.Utf8);
      decryptObj[idx] = decryptedDataRow;
    });
    console.log(decryptObj)
    return decryptObj;
  }
  else if (typeof (encryptedData) === "string") {
    let decryptedData = CryptoJS.AES.decrypt(encryptedData, key, { iv: CryptoJS.enc.Hex.parse(iv) }).toString(CryptoJS.enc.Utf8);
    return decryptedData;
  }
  else {
    return null;
  }

}

// JS file load on runtime

export const LoadJs = (url) =>{

  const script = document.createElement("script")

  script.type = "text/javascript";
  script.src = url;
  script.setAttribute("data-url", url);

  script.onerror = () =>{
    console.error(`Error loading script: ${url}`);
  };

  document.body.appendChild(script)
}

export const RemoveJs = (url) => {
  const scripts = document.querySelectorAll(`script[data-url='${url}']`);
  scripts.forEach(script => script.parentNode.removeChild(script));
};

// Encrypt Paylod


export function encryptString(data) {
  try {
    const jsonString = JSON.stringify(data);
    let encodedText = '';
    for (let i = 0; i < jsonString.length; i++) {
      const char = jsonString[i];
      const encodedChar = String.fromCharCode(char.charCodeAt(0) + window.Configs.keyValue);
      encodedText += encodedChar;
    }
    const base64EncodedText = btoa(encodedText);
    // Wrap the base64 encoded string in a JSON object
    return {
    data: base64EncodedText
    };
  } catch (error) {
    console.error('Encryption failed:', error.message);
    return { data: '' }; // Return an object with an empty string in case of failure
  }
}

// Decrypt Payload

export function decryptString(encryptedObject) {
  try {
    const base64EncodedText = encryptedObject.data;

    const decodedText = atob(base64EncodedText);
    let decodedString = '';

    // Reverse the character shift
    for (let i = 0; i < decodedText.length; i++) {
      const char = decodedText[i];
      const decodedChar = String.fromCharCode(char.charCodeAt(0) - window.Configs.keyValue);
      decodedString += decodedChar;
    }

    // Parse the JSON string back into an object
    return JSON.parse(decodedString);
  } catch (error) {
    console.error('Decryption failed:', error.message);
    return encryptedObject; // Return the original object in case of 
  }
}


// export Validate Dial Number and Unique Id
export const validateDialInput = (number, mode) => {
  if (!number) {
    return { valid: false, message: "Number cannot be empty" };
  }

  const alphanumericRegex = /^[a-zA-Z0-9]+$/;
  const numericRegex = /^[0-9]+$/;
  const hasLetter = /[a-zA-Z]/.test(number);

  if (mode === "uniqueDial") {
    if (!alphanumericRegex.test(number) || !hasLetter) {
      return { valid: false, message: "Unique ID must contain both letters and numbers" };
    }
  } 
  else if(mode === "symbolDial") {
    const maxDigits = window?.Configs?.maxDigitsAllowed ?? 15;
    if (number.length > maxDigits) {
      return { valid: false, message: `Maximum length for phone number is ${maxDigits}`};
    }
  }
  else {
    const maxDigits = window?.Configs?.maxDigitsAllowed ?? 15;
    if (number.length > maxDigits) {
      return { valid: false, message: `Maximum length for phone number is ${maxDigits}` };
    }
  }

  return { valid: true };
};
